(ns manage.content-variant-page.view.import-warnings
  (:require ["@mui/icons-material/List$default" :as ListIcon]
            ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/AlertTitle$default" :as AlertTitle]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Divider$default" :as Divider]
            ["@mui/material/List$default" :as List]
            ["@mui/material/ListItem$default" :as ListItem]
            ["@mui/material/ListItemText$default" :as ListItemText]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/Typography$default" :as Typography]
            ["src/svg/inform/cross-square.svg$default" :as ErrorIcon]
            ["src/svg/inform/error-triangle-fill.svg$default" :as AlertIcon]
            [clojure.string :as str]
            [common.localstorage :as local-storage]
            [common.modal.view :refer [defmodal modal-v2]]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn do-we-got-errors?
  [{:keys [import-error-total]}]
  (pos-int? import-error-total))

(defn close-warning
  [import-id]
  (rf/dispatch [:page.content-variant/save-import-warnings import-id]))

(defui import-warnings
  [{:keys [isImportRunning importErrorsStats]}]
  (uix/use-effect (fn []
                    (let [stored-warnings (local-storage/get :suppressed-import-warnings)]
                      (rf/dispatch [:page.content-variant/load-suppressed-import-warnings-ids stored-warnings])))
                  [importErrorsStats])
  (let [import-id (:id importErrorsStats)
        feed-id (:feed-id importErrorsStats)
        is-already-suppressed? (use-subscribe [:page.content-variant/is-import-warnings-suppressed? import-id])]
    (when (and (not isImportRunning) (not is-already-suppressed?) (do-we-got-errors? importErrorsStats))
      (let [total-errors (:variant-error-total importErrorsStats)
            warning-title (str total-errors " variant" (when (not= total-errors 1) "s") " couldn't be updated")
            warning-text "We regret to inform you that certain variants could not be updated due to multiple reasons. To resolve this issue, please review the affected variants and take appropriate action."]
        ($ Alert
           {:severity "warning"
            :icon ($ AlertIcon)
            :onClose #(close-warning (:id importErrorsStats))
            :sx #js {:mb 1}}
           ($ AlertTitle
              {:sx #js {:paddingTop 0.5}}
              warning-title)
           ($ Stack {:direction "column"
                     :alignItems "flex-start"
                     :gap 1.2
                     :py 1}
              warning-text
              ($ Button {:variant "contained"
                         :color "warning"
                         :on-click #(rf/dispatch [:modal/open
                                                  {:id :content-page/import-errors
                                                   :props {:import-errors importErrorsStats
                                                           :feed-id feed-id
                                                           :import-id import-id}}])
                         :startIcon ($ ListIcon)}
                 "Show import errors")))))))

(defmodal show-error-details :content-page/import-errors
  [{:keys [import-errors import-id feed-id]}]
  (let [{:keys [aggregated-errors errors-count]} import-errors
        has-errors? (pos? errors-count)
        ;; using vector for consistent order
        column-name-mapping (->> [:variants-deleted "Number of variants deleted"
                                  :variants-after-import "Number of variants after the import"
                                  :variants-updated "Number of variants updated"
                                  :variants-before-import "Number of variants before the import"
                                  :variants-inserted "Number of variants inserted"
                                  :import-error-total "Number of import errors"
                                  :rows-in-feed "Number of rows in import file"]
                                 (partition 2))]
    ($ modal-v2
       {:title (if has-errors? "Import errors" "Import details")
        :icon (when has-errors?
                ($ SvgIcon
                   {:color "warning"
                    :component AlertIcon}))
        :footer ($ Button {:variant "contained"
                           :color "warning"
                           :on-click #(rf/dispatch [:content-page/download-errors feed-id import-id])}
                   "Download full list")}
       ($ Stack {:sx #js {:minWidth 580 :minHeight 320}}
          ($ List
             (for [[meta-key meta-label] column-name-mapping]
               (let [meta-value (get import-errors meta-key 0)]
                 ($ Stack {:key meta-key}
                    ($ ListItem {:key meta-key :disable-padding true}
                       ($ ListItemText {:primary meta-label
                                        :secondaryTypographyProps #js {:color (if (and (= meta-key :import-error-total) (> meta-value 0))
                                                                                "red"
                                                                                "green")}
                                        :secondary meta-value}))
                    ($ Divider {:component "li"})))))
          (for [error aggregated-errors]
            ($ Stack
               {:key (str (:row-numbers error) (:message error) (:columns-affected error))
                :direction "row"
                :gap 1
                :p 2
                :align-items "center"}
               ($ ErrorIcon)
               ($ Stack
                  ($ Typography {:variant "h4"}
                     (if-let [row-numbers (:row-numbers error)]
                       (str "ROW NUMBERS: " row-numbers)
                       ""))
                  ($ Typography {:variant "h4"}
                     (if-let [columns-affected (seq (:columns-affected error))]
                       (str "COLUMN(S): " (str/join ", " columns-affected))
                       ""))

                  ($ Typography (:message error)))))))))
